import React, { useState, useEffect } from "react";
import UserNavbar from "../../components/UserNavbar";
import Sidebar from "../../components/Sidebar";
import Content from "../../components/Content";
import UserList from "./UserList";
import CustomToaster from "../../components/CustomToaster";
import "../../styles/UserList.css";

const index = ({ pageID, title }) => {
  const [toggleBtn, setToggleBtn] = useState(false);
  const toggle = () => setToggleBtn((val) => !val);
  const [navTitle, setnavTitle] = useState("Admin Console");
  const [NavbarCollapse, setNavbarCollapse] = useState(true);
  const [openUserAdd, setOpenUserAdd] = useState(false);
  const [usersCount, setUsersCount] = useState(0);
  const [toasterVisible, setToasterVisible] = useState(false);
  const [toasterMessage, setToasterMessage] = useState("");
  const [toasterAppearance, setToasterAppearance] = useState("success");
  const [userSearchData, setuserSearchData] = useState("");

  useEffect(() => {
    setnavTitle(title);
  }, [title]);

  const handleCloseButtonClick = () => {
    setToggleBtn(false); // Set toggleBtn to false
  };

  const handleOpenUserAdd = () => {
    setOpenUserAdd(true);
  };

  const handleSendUsersCount = (count) => {
    setUsersCount(count);
  };

  const handleuserSearchData = (data) => {
    setuserSearchData(data);
  };

  const showToaster = (message, appearance) => {
    setToasterVisible(true);
    setToasterMessage(message);
    setToasterAppearance(appearance);
  };

  const closeToaster = () => {
    setToasterVisible(false);
  };

  return (
    <div className="top-wrapper">
      <Sidebar
        toggleBtn={toggleBtn}
        onCloseButtonClick={handleCloseButtonClick}
        activeMenu="Admin Console"
      />
      <UserNavbar
        setToggle={toggle}
        handleOpenUserAdd={handleOpenUserAdd}
        showDatasetCount={usersCount}
        navTitle={navTitle}
        type={pageID}
        NavbarCollapse={NavbarCollapse}
        userSearchData={handleuserSearchData}
      />
      <Content toggleBtn={toggleBtn}>
        <div className="dataconsole-responsvive-body">
          {toasterVisible && (
            <CustomToaster
              message={toasterMessage}
              duration={3000}
              onClose={closeToaster}
              position="right-top"
              appearance={toasterAppearance}
            />
          )}
          <UserList
            openUserAdd={openUserAdd}
            handleCloseUserAdd={() => setOpenUserAdd(false)}
            onSendUsersCount={handleSendUsersCount}
            showToaster={showToaster}
            userSearchData={userSearchData}
          />
        </div>
      </Content>
    </div>
  );
};

export default index;
